/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './doctor-details.reducer';

export const DoctorDetails = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const doctorDetailsList = useAppSelector(state => state.doctorDetails.entities);
  const loading = useAppSelector(state => state.doctorDetails.loading);
  const totalItems = useAppSelector(state => state.doctorDetails.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="doctor-details-heading" data-cy="DoctorDetailsHeading">
        <Translate contentKey="tinyMedicRestApp.doctorDetails.home.title">Doctor Details</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.doctorDetails.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/doctor-details/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.doctorDetails.home.createLabel">Create new Doctor Details</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.doctorDetails.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {doctorDetailsList && doctorDetailsList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('workExperience')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.workExperience">Work Experience</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('workExperience')} />
                </th>
                <th className="hand" onClick={sort('dutyStartTime')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.dutyStartTime">Duty Start Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dutyStartTime')} />
                </th>
                <th className="hand" onClick={sort('dutyEndTime')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.dutyEndTime">Duty End Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dutyEndTime')} />
                </th>
                <th className="hand" onClick={sort('tmPermanent')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.tmPermanent">Tm Permanent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tmPermanent')} />
                </th>
                <th className="hand" onClick={sort('createdDtm')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.createdDtm">Created Dtm</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdDtm')} />
                </th>
                <th className="hand" onClick={sort('createdBy')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.createdBy">Created By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdBy')} />
                </th>
                <th className="hand" onClick={sort('modifiedBy')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.modifiedBy">Modified By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedBy')} />
                </th>
                <th className="hand" onClick={sort('dob')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.dob">Dob</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dob')} />
                </th>
                <th className="hand" onClick={sort('height')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.height">Height</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('height')} />
                </th>
                <th className="hand" onClick={sort('weight')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.weight">Weight</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('weight')} />
                </th>
                <th className="hand" onClick={sort('registrationCode')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.registrationCode">Registration Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('registrationCode')} />
                </th>
                <th className="hand" onClick={sort('registrationNumber')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.registrationNumber">Registration Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('registrationNumber')} />
                </th>
                <th className="hand" onClick={sort('registrationValidUpto')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.registrationValidUpto">Registration Valid Upto</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('registrationValidUpto')} />
                </th>
                <th className="hand" onClick={sort('knownLanguages')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.knownLanguages">Known Languages</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('knownLanguages')} />
                </th>
                <th className="hand" onClick={sort('qualification')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.qualification">Qualification</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qualification')} />
                </th>
                <th className="hand" onClick={sort('referredBy')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.referredBy">Referred By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredBy')} />
                </th>
                <th className="hand" onClick={sort('bio')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.bio">Bio</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bio')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('practicingCity')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.practicingCity">Practicing City</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('practicingCity')} />
                </th>
                <th className="hand" onClick={sort('gender')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.gender">Gender</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gender')} />
                </th>
                <th className="hand" onClick={sort('bloodGroup')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.bloodGroup">Blood Group</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodGroup')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.doctorDetails.contactCode">Contact Code</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {doctorDetailsList.map((doctorDetails, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/doctor-details/${doctorDetails.id}`} color="link" size="sm">
                      {doctorDetails.id}
                    </Button>
                  </td>
                  <td>{doctorDetails.workExperience}</td>
                  <td>{doctorDetails.dutyStartTime}</td>
                  <td>{doctorDetails.dutyEndTime}</td>
                  <td>{doctorDetails.tmPermanent}</td>
                  <td>{doctorDetails.createdDtm}</td>
                  <td>{doctorDetails.createdBy}</td>
                  <td>{doctorDetails.modifiedBy}</td>
                  <td>{doctorDetails.dob}</td>
                  <td>{doctorDetails.height}</td>
                  <td>{doctorDetails.weight}</td>
                  <td>{doctorDetails.registrationCode}</td>
                  <td>{doctorDetails.registrationNumber}</td>
                  <td>{doctorDetails.registrationValidUpto}</td>
                  <td>{doctorDetails.knownLanguages}</td>
                  <td>{doctorDetails.qualification}</td>
                  <td>{doctorDetails.referredBy}</td>
                  <td>{doctorDetails.bio}</td>
                  <td>{doctorDetails.timestampentry}</td>
                  <td>{doctorDetails.microSec}</td>
                  <td>{doctorDetails.lastupdated}</td>
                  <td>{doctorDetails.active ? 'true' : 'false'}</td>
                  <td>{doctorDetails.cursor}</td>
                  <td>{doctorDetails.practicingCity}</td>
                  <td>{doctorDetails.gender}</td>
                  <td>{doctorDetails.bloodGroup}</td>
                  <td>
                    {doctorDetails.contactCode ? (
                      <Link to={`/contact-details/${doctorDetails.contactCode.id}`}>{doctorDetails.contactCode.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/doctor-details/${doctorDetails.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/doctor-details/${doctorDetails.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/doctor-details/${doctorDetails.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.home.notFound">No Doctor Details found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={doctorDetailsList && doctorDetailsList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DoctorDetails;
